import api from '@/services/api'

export default {
    fetchShareLinks(params) {
        return api.get(`links/`, {params})
            .then(response => response.data)
    },
    postShareLink(link) {
        return api.post(`links/`, link)
            .then(response => response.data)
    },
    editShareLink(link) {
        return api.put(`links/${link.uuid}/`, link)
            .then(response => response.data)
    },
    getShareLink(params) {
        return api.get(`links/${params.uuid}/`)
            .then(response => response.data)
    },
    deleteShareLink(params) {
        return api.delete(`links/${params.uuid}/`)
            .then(response => response.data)
    }
}